/**
 * Caderno — onde os palpites ficam anotados entre uma sessao e outra.
 *
 * O motor `palpitar` e o unico com estado que atravessa sessoes: a crianca
 * preve alguma coisa hoje e o resultado aparece dias depois. O caderno e onde
 * essa espera fica visivel.
 *
 * D6: quando o palpite se resolve, NUNCA se diz que ela acertou ou errou. Diz-se
 * o que aconteceu. A secao 10 repete a mesma regra para o relatorio dos pais:
 * "nunca mencionar acerto ou erro de palpite".
 */

let estiloInjetado = false;

function injetarEstilo() {
  if (estiloInjetado) return;
  estiloInjetado = true;

  const estilo = document.createElement('style');
  estilo.textContent = `
    .caderno {
      position: fixed;
      inset: 0;
      background: rgba(38, 42, 34, 0.86);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 50;
    }
    .caderno__folha {
      background: #fdf6e3;
      color: #3b3a30;
      font-family: system-ui, -apple-system, sans-serif;
      width: min(86vw, 640px);
      max-height: 76vh;
      overflow-y: auto;
      border-radius: 22px;
      padding: 32px 36px;
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
    }
    .caderno__folha h2 { margin: 0 0 18px; font-size: 30px; }
    .caderno__item {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 16px 0;
      border-bottom: 2px dashed #d8cfae;
      font-size: 24px;
    }
    .caderno__item:last-child { border-bottom: none; }
    .caderno__marca { font-size: 34px; }
    .caderno__vazio { font-size: 24px; opacity: 0.7; }
  `;
  document.head.appendChild(estilo);
}

export class Caderno {
  constructor(conteudo) {
    injetarEstilo();
    this.conteudo = conteudo;
  }

  /**
   * Abre o caderno mostrando os palpites.
   * @param {object} estado estado da fazenda
   * @param {Function} aoFechar
   */
  abrir(estado, aoFechar) {
    const fundo = document.createElement('div');
    fundo.className = 'caderno';

    const folha = document.createElement('div');
    folha.className = 'caderno__folha';
    folha.innerHTML = '<h2>Meu caderno de palpites</h2>';

    if (estado.caderno.length === 0) {
      const vazio = document.createElement('p');
      vazio.className = 'caderno__vazio';
      vazio.textContent = 'Ainda nao tem nenhum palpite aqui. Logo vai ter!';
      folha.appendChild(vazio);
    } else {
      for (const anotacao of [...estado.caderno].reverse()) {
        folha.appendChild(this.criarItem(anotacao, estado.dia));
      }
    }

    fundo.appendChild(folha);
    fundo.addEventListener('click', (e) => {
      if (e.target === fundo) {
        fundo.remove();
        aoFechar?.();
      }
    });

    document.body.appendChild(fundo);
    return fundo;
  }

  criarItem(anotacao, diaAtual) {
    const item = document.createElement('div');
    item.className = 'caderno__item';

    const marca = document.createElement('span');
    marca.className = 'caderno__marca';
    // D6 — sem check verde nem X vermelho. Semente esperando ou planta crescida.
    marca.textContent = anotacao.resolvido ? '\u{1F331}' : '\u{1F4AD}';
    item.appendChild(marca);

    const texto = document.createElement('span');
    const diasEsperando = diaAtual - anotacao.dia;
    const palpite = anotacao.palpite ?? 'alguma coisa';

    texto.textContent = anotacao.resolvido
      ? `Voce palpitou ${palpite}. Ja da para ver o que aconteceu!`
      : `Voce palpitou ${palpite}. Esperando ha ${diasEsperando} dia(s).`;

    item.appendChild(texto);
    return item;
  }
}
